import React, { useState, useEffect, useContext } from "react";
import { TokenVerificationLoggedin, ScreenViewOnboarding, BlockOtherThanAdmin } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import configData from "../config/config.json";
// import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import { Button } from "react-bootstrap";
import constantData from "../constants/constantData.json";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import loaderIcon from '../assets/images/icons/loader.gif';
import googleIcon from '../assets/images/icons/google-ads.svg';
import uploadIcon from '../assets/images/icons/upload-cloud.svg';
import pptIcon from '../assets/images/icons/ppt.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import { Col, Row, Input, Space, Select, Radio, Switch, Upload } from 'antd';
import timeIcon from "../assets/images/icons/ph_timer.svg";
import { default as ReactSelect } from 'react-select';
import FullLoader from "../assets/images/full-page-loader.gif"
import onboardingBanner from "../assets/logo/onboarding_banner.svg"

const { Dragger } = Upload;

const Onboarding = () => {
  const loadingContext = useContext(LoadingContext);

  useEffect(() => {
    TokenVerificationLoggedin();
    ScreenViewOnboarding();
    BlockOtherThanAdmin();


    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      let id = jwtDecode(token)._id

      axios
        .get(configData.SERVER_URL + "user/status?_id=" + id)
        .then((response) => {
          if (response.data.data.status === "verified") {

            setTimeout(() => {
              setStep(response.data.data.onboarding)
            }, 300)

          }
        })
        .catch((error) => { });

      axios
        .get(configData.SERVER_URL + "user/profile", {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          setName(response.data.data.p_name);
          setCompanyName(response.data.data.o_name);
          setEmail(response.data.data.email);
          setCompanyWebsite(response.data.data.c_website);
          setIm(response.data.data.im.value);
          setSelectedIm(response.data.data.im.label);
          setSellerName(response.data.data.o_name);
        })
        .catch((error) => { });


      axios
        .get(configData.SERVER_URL + "user/countryList", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setCountryOptions(response.data.data);
        })
        .catch((error) => { });

      axios
        .get(configData.SERVER_URL + "user/dialCodeList", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setDialCodeOptions(response.data.data);
        })
        .catch((error) => { });
    }

    loadingContext.done();
  }, [loadingContext]);

  ///////////////////////////////////////////onboarding related code starts  /////////////////////////////////////////////////////////////////////////////
  const formatOptionLabel = ({ value, label }) => (
    <div className="d-flex gap-10">
      <span>{label}</span><b>{value}</b>
      {/* <b>{label}</b> */}
    </div>
  );
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
      display: 'flex',
      alignItems: 'center',
    }),
  };


  useEffect(() => {
    const inputs = document.querySelectorAll('.ant-select-selection-search-input');

    inputs.forEach(input => {
      const handleInput = () => {
        const parent = input.closest('.ant-select-selection-search');
        if (input.value.length > 0) {
          parent.classList.add('searching');
        } else {
          parent.classList.remove('searching');
        }
      };

      input.addEventListener('input', handleInput);

      // Cleanup event listener on component unmount
      return () => {
        input.removeEventListener('input', handleInput);
      };
    });
  });






  //   const buttonRef3 = useRef(null);
  const [step, setStep] = useState(-1);

  const [name, setName] = useState("");
  const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

  const [companyName, setCompanyName] = useState("");
  const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
    useState(false);

  const [email, setEmail] = useState("");
  const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
  const [emailUrlError, setEmailUrlError] = useState(false);

  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
    useState(false);
  const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

  const [im, setIm] = useState("");
  const [imIsRequiredError, setImIsRequiredError] = useState(false);

  const [selectedIm, setSelectedIm] = useState("skype");

  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");

  const [countryOptions, setCountryOptions] = useState([]);
  const [country, setCountry] = useState("");
  const [countryIsRequiredError, setCountryIsRequiredError] = useState(false);

  const [dialCodeOptions, setDialCodeOptions] = useState([]);
  const [dialCode, setDialCode] = useState({ label: "+91", value: "+91" });
  const [phone, setPhone] = useState("");
  const [phoneIsRequiredError, setPhoneIsRequiredError] = useState(false);

  const [companyLinkedin, setCompanyLinkedin] = useState("");
  const [companyLinkedinUrlError, setCompanyLinkedinUrlError] = useState(false);

  const [sellerType, setSellerType] = useState("Publisher");

  const [sellerName, setSellerName] = useState("");
  const [sellerNameIsRequiredError, setSellerNameIsRequiredError] =
    useState(false);

  const [sellerDomain, setSellerDomain] = useState("");
  const [sellerDomainIsRequiredError, setSellerDomainIsRequiredError] =
    useState(false);
  const [sellerDomainUrlError, setSellerDomainUrlError] = useState(false);

  const [isGamChecked, setIsGamChecked] = useState(false);
  const [networkId, setNetworkId] = useState("");

  const [mediakit, setMediakit] = useState([]);

  const [buttonValue, setButtonValue] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validateWebsiteUrl = (websiteUrl) => {
    return String(websiteUrl)
      .toLowerCase()
      .match(/.+[.].+/);
  };

  const validateLinkedinUrl = (linkedinUrl) => {
    return String(linkedinUrl)
      .toLowerCase()
      .match(/^(https?:\/\/)?([^\/]+\.)?(linkedin\.[a-zA-Z]+\/.*)$/);
  };

  function onChangeName(event) {
    setNameIsRequiredError(false);
    setName(event.target.value);
  }

  function onBlurName(event) {
    if (event.target.value.trim().length === 0) {
      setNameIsRequiredError(true);
    }
    setName(event.target.value.trim());
  }

  function onChangeCompanyName(event) {
    setCompanyNameIsRequiredError(false);
    setCompanyName(event.target.value);
  }

  function onBlurCompanyName(event) {
    if (event.target.value.trim().length === 0) {
      setCompanyNameIsRequiredError(true);
      setCompanyName("");
    }
    setCompanyName(event.target.value.trim());
  }

  function onChangeEmail(event) {
    setEmailIsRequiredError(false);
    setEmail(event.target.value);

    if (validateEmail(event.target.value) === null) {
      setEmailUrlError(true);
    } else {
      setEmailUrlError(false);
    }
  }

  function onBlurEmail(event) {
    if (event.target.value.trim().length === 0) {
      setEmailUrlError(false);
      setEmailIsRequiredError(true);
    } else {
      if (validateEmail(event.target.value.trim()) === null) {
        setEmailUrlError(true);
      } else {
        setEmailUrlError(false);
      }
    }
    setEmail(event.target.value.trim());
  }

  function onChangeIm(event) {
    setImIsRequiredError(false);
    setIm(event.target.value);
  }

  function onBlurIm(event) {
    if (event.target.value.trim().length === 0) {
      setImIsRequiredError(true);
    }
    setIm(event.target.value.trim());
  }

  function onChangeSelectedIm(event) {
    setSelectedIm(event);
  }

  function onChangeCompanyWebsite(event) {
    setCompanyWebsite(event.target.value);

    if (event.target.value.length === 0) {
      setCompanyWebsiteUrlError(false);
      setCompanyWebsiteIsRequiredError(true);
    } else {
      setCompanyWebsiteIsRequiredError(false);

      if (validateWebsiteUrl(event.target.value) === null) {
        setCompanyWebsiteUrlError(true);
      } else {
        setCompanyWebsiteUrlError(false);
      }
    }
  }

  function onBlurCompanyWebsite(event) {
    if (event.target.value.trim().length === 0) {
      setCompanyWebsiteUrlError(false);
      setCompanyWebsiteIsRequiredError(true);
    } else {
      if (validateWebsiteUrl(event.target.value.trim()) === null) {
        setCompanyWebsiteUrlError(true);
      } else {
        setCompanyWebsiteUrlError(false);
      }
    }
    setCompanyWebsite(event.target.value.trim());
  }

  function onChangeAddress(event) {
    setAddress(event.target.value);
  }

  function onBlurAddress(event) {
    setAddress(event.target.value.trim());
  }

  function onChangeState(event) {
    setState(event.target.value);
  }

  function onBlurState(event) {
    setState(event.target.value.trim());
  }

  function onChangeCity(event) {
    setCity(event.target.value);
  }

  function onBlurCity(event) {
    setCity(event.target.value.trim());
  }

  function onChangePincode(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setPincode(event.target.value.trim());
    }
  }

  function onBlurPincode(event) {
    setPincode(event.target.value.trim())
  }

  function onChangePhone(event) {
    setPhoneIsRequiredError(false);
    if (/^\d*$/.test(event.target.value.trim())) {
      setPhone(event.target.value.trim());
    }
  }

  function onBlurPhone(event) {
    if (event.target.value.trim().length === 0) {
      setPhoneIsRequiredError(true);
    }
    setPhone(event.target.value.trim());
  }


  function onChangeCompanyLinkedin(event) {
    setCompanyLinkedin(event.target.value);
    if (event.target.value.length === 0) {
      setCompanyLinkedinUrlError(false);
    } else {
      if (validateLinkedinUrl(event.target.value) === null) {
        setCompanyLinkedinUrlError(true);
      } else {
        setCompanyLinkedinUrlError(false);
      }
    }
  }

  function onBlurCompanyLinkedin(event) {
    if (event.target.value.trim().length === 0) {
      setCompanyLinkedinUrlError(false);
    }
    else {
      if (validateLinkedinUrl(event.target.value.trim()) === null) {
        setCompanyLinkedinUrlError(true);
      } else {
        setCompanyLinkedinUrlError(false);
      }
    }
    setCompanyLinkedin(event.target.value.trim());
  }

  function onChangeSellerType(event) {
    setSellerType(event.target.value);
  }

  function onChangeSellerName(event) {
    setSellerNameIsRequiredError(false);
    setSellerName(event.target.value);
  }

  function onBlurSellerName(event) {
    if (event.target.value.trim().length === 0) {
      setSellerNameIsRequiredError(true);
    }
    setSellerName(event.target.value.trim());
  }

  function onChangeSellerDomain(event) {
    setSellerDomain(event.target.value);

    if (event.target.value.length === 0) {
      setSellerDomainUrlError(false);
      setSellerDomainIsRequiredError(true);
    } else {
      setSellerDomainIsRequiredError(false);

      if (validateWebsiteUrl(event.target.value) === null) {
        setSellerDomainUrlError(true);
      } else {
        setSellerDomainUrlError(false);
      }
    }
  }

  function onBlurSellerDomain(event) {
    if (event.target.value.trim().length === 0) {
      setSellerDomainUrlError(false);
      setSellerDomainIsRequiredError(true);
    } else {
      if (validateWebsiteUrl(event.target.value.trim()) === null) {
        setSellerDomainUrlError(true);
      } else {
        setSellerDomainUrlError(false);
      }
    }
    setSellerDomain(event.target.value.trim());
  }

  const [dragging, setDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);

    let count = 0;

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (droppedFiles.length > 0) {
      let tempMediaKit = [...mediakit];
      for (let file of droppedFiles) {

        if (file.size / (1024 * 1024) < 100 && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")) {
          tempMediaKit.push({
            data: file,
            preview: URL.createObjectURL(file),
            filename: file.name,
            size: file.size
          });
        }
        else {
          count++;

        }
      }
      setMediakit(tempMediaKit);
      const fileInput00 = document.getElementById("file000");
      fileInput00.value = "";
      if (count !== 0) {
        notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && ppt/pptx format`)
      }
    }
  };

  function onChangeMediakit(e) {
    let count = 0;

    if (e.target.files.length > 0) {
      let tempMediaKit = [...mediakit];

      for (let file of e.target.files) {

        if (file.size / (1024 * 1024) < 100 && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")) {
          tempMediaKit.push({
            data: file,
            preview: URL.createObjectURL(file),
            filename: file.name,
            size: file.size
          });
        }
        else {
          count++;

        }
      }
      setMediakit(tempMediaKit);
      const fileInput00 = document.getElementById("file000");
      fileInput00.value = "";

      if (count !== 0) {
        notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && ppt/pptx format`)
      }

      //   } else {
      //     setMediakit({
      //       data: "",
      //       preview: "",
      //     });
      //     setMediakitFilename("");
      //     notifyfailure("File Size Should be less than 100 MB");
      //   }
    }
  }


  // function onChangeMediakit(e) {


  //   if (e.target.files === undefined) {
  //   } else {
  //     let tempMediaKit = [...mediakit];
  //     //   if (e.target.files[0].size / (1024 * 1024) < 100) {
  //     tempMediaKit.push({
  //       data: e.target.files[0],
  //       preview: URL.createObjectURL(e.target.files[0]),
  //       filename: e.target.files[0].name,
  //       size:e.target.files[0].size
  //     });
  //     setMediakit(tempMediaKit);
  //     const fileInput00 = document.getElementById("file000");
  //     fileInput00.value = "";

  //     //   } else {
  //     //     setMediakit({
  //     //       data: "",
  //     //       preview: "",
  //     //     });
  //     //     setMediakitFilename("");
  //     //     notifyfailure("File Size Should be less than 100 MB");
  //     //   }
  //   }
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      name !== "" &&
      companyName !== "" &&
      email !== "" &&
      companyWebsite !== "" &&
      im !== "" &&
      country !== "" &&
      phone !== "" &&
      sellerName !== "" &&
      sellerDomain !== ""

    ) {
      if (
        nameIsRequiredError === false &&
        companyNameIsRequiredError === false &&
        emailIsRequiredError === false &&
        emailUrlError === false &&
        companyWebsiteUrlError === false &&
        companyWebsiteIsRequiredError === false &&
        imIsRequiredError === false &&
        countryIsRequiredError === false &&
        phoneIsRequiredError === false &&
        companyLinkedinUrlError === false &&
        sellerNameIsRequiredError === false &&
        sellerDomainIsRequiredError === false &&
        sellerDomainUrlError === false

      ) {


        let formData = new FormData();

        formData.append("p_name", name);
        formData.append("o_name", companyName);
        formData.append("email", email);
        formData.append("c_website", companyWebsite);
        formData.append("im", JSON.stringify({ "label": selectedIm, "value": im }));
        formData.append("address", address);
        formData.append("state", state);
        formData.append("city", city);
        formData.append("pincode", pincode);
        formData.append("country", country);
        formData.append("o_contact", companyLinkedin);
        formData.append("phone", JSON.stringify({ "code": dialCode.value, "p_number": phone }));
        formData.append("s_type", sellerType);
        formData.append("s_name", sellerName);
        formData.append("s_domain", sellerDomain);
        formData.append("gam_check", isGamChecked);
        formData.append("networkId", isGamChecked ? networkId : "");

        mediakit.forEach((file) => {
          formData.append('mediaKit', file.data);
        });




        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

          setButtonValue(true);
          let token = Cookies.get("token_xapads_ssp");
          let id = jwtDecode(token)._id;

          axios
            .post(configData.SERVER_URL + `user/onboard?_id=${id}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                "x-access-token": token,
              }
            }
            )
            .then((response) => {
              // notifysuccess(response.data.message);
              setStep(2)
              // setTimeout(() => {
              //   window.location.replace("/login");
              // }, 1500);
            })
            .catch((error) => {
              if (error?.response) {
                if (error.response.data.message?.length !== 0) {
                  notifyfailure(error.response.data.message);
                }
              } else {
                notifycatch();
              }
              setButtonValue(false);
            });
        }
      }
    } else {
      if (name === "") {
        setNameIsRequiredError(true);
      }
      if (companyName === "") {
        setCompanyNameIsRequiredError(true);
      }
      if (email === "") {
        setEmailIsRequiredError(true);
      }
      if (companyWebsite === "") {
        setCompanyWebsiteIsRequiredError(true);
      }
      if (im === "") {
        setImIsRequiredError(true);
      }
      if (country === "") {
        setCountryIsRequiredError(true);
      }
      if (phone === "") {
        setPhoneIsRequiredError(true);
      }
      if (sellerName === "") {
        setSellerNameIsRequiredError(true);
      }
      if (sellerDomain === "") {
        setSellerDomainIsRequiredError(true);
      }
    }
  };

  ///////////////////////////////////////////onboarding related code ends /////////////////////////////////////////////////////////////////////////////

  if (step === 0) {
    return (
      <div className="container_box--main">
        <div className="container_box_start">
        </div>

        <div className="container_box_end d_flex flex_column justify_content_center">
          <div className="container_box_end--width">
            <div className="container_box--intro onb">
              <h1 className='heading'>Welcome to Helix!</h1>
              <p className='text'>To kick things off, we'd love to learn more about your company to better <br /> serve your needs.</p>
            </div>
            <div className="dummy_img">
              <img
                src={onboardingBanner}
                alt="USP" />
            </div>
            <Button className='btn_primary btn w_lg border-0'
              onClick={() => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                  let token = Cookies.get("token_xapads_ssp")

                  axios
                    .post(configData.SERVER_URL + "user/onboardUpdate", {}, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setStep(1)
                    })
                    .catch((error) => { });
                }

              }}
            >
              <span>let’s get started</span>
              <img src={loaderIcon} alt='USP' className='loader_icon' />
            </Button>
          </div>
        </div>
      </div>



    )
  }
  else if (step === 1) {
    return (

      <div className="container_box--main">
        <div className="container_box_start">
        </div>

        <div className="container_box_end">

          <div className="container_box_end--width">

            <div className="container_box--intro onb mt_74">
              <h1 className='heading'>To know your company better</h1>
              <p className='text'>Add some more information about your company.</p>
            </div>

            <h2 className="sub_heading">
              Basic Details
            </h2>
            <div className="container_box--form-container">
              <Row gutter={16}>
                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>Name *</label>
                    <Input
                      className={
                        nameIsRequiredError
                          ? "form_control basic error"
                          : "form_control basic"
                      }
                      value={name}
                      onBlur={onBlurName}
                      onChange={onChangeName}
                      autocomplete="off"
                    />

                    <span className='error_content'>
                      {nameIsRequiredError && (
                        <> This field is required</>
                      )}
                    </span>

                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>Organisation Name *</label>
                    <Input
                      className={
                        companyNameIsRequiredError
                          ? "form_control basic error"
                          : "form_control basic"
                      }
                      value={companyName}
                      onBlur={onBlurCompanyName}
                      onChange={onChangeCompanyName}
                      autocomplete="off"
                    />

                    <span className="error_content">
                      {companyNameIsRequiredError && (
                        <> This field is required</>
                      )}
                    </span>

                  </div>
                </Col>

                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>Email Address *</label>
                    <Input
                      className="form_control basic"
                      value={email}
                      disabled
                    />

                    <span className="error_content">
                    </span>
                  </div>
                </Col>

                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>Company website *</label>
                    <Input
                      className={
                        (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                          ? "form_control basic error"
                          : "form_control basic"
                      }
                      value={companyWebsite}
                      onBlur={onBlurCompanyWebsite}
                      onChange={onChangeCompanyWebsite}
                      autocomplete="off"
                    />
                    <span className="error_content">
                      {companyWebsiteIsRequiredError && (
                        <> This field is required</>
                      )}
                      {companyWebsiteUrlError && (
                        <> Invalid Website Url</>
                      )}

                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group mb_0">
                    <label className='form_label'>IM  *</label>
                    <Space.Compact className='form_compact basic'>
                      <Select
                        className='form_select'
                        value={selectedIm}
                        onChange={onChangeSelectedIm}
                        options={constantData.IM_OPTIONS}
                      />
                      <Input
                        className={imIsRequiredError
                          ? "form_control basic error"
                          : "form_control basic"
                        }
                        value={im}
                        onChange={onChangeIm}
                        onBlur={onBlurIm}
                        autocomplete="off"
                      />
                    </Space.Compact>
                    <span className="error_content">
                      {imIsRequiredError && (
                        <> This field is required</>
                      )}

                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <h2 className="sub_heading">
              Address
            </h2>
            <div className="container_box--form-container">
              <Row gutter={16}>
                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>Address Line 1</label>
                    <Input
                      className='form_control basic'
                      value={address}
                      onBlur={onBlurAddress}
                      onChange={onChangeAddress}
                      autocomplete="off"
                    />

                    <span className="error_content">
                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>City </label>
                    <Input
                      className='form_control basic'
                      value={city}
                      onBlur={onBlurCity}
                      onChange={onChangeCity}
                      autocomplete="off"
                    />

                    <span className="error_content">
                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>State</label>
                    <Input
                      className='form_control basic'
                      value={state}
                      onBlur={onBlurState}
                      onChange={onChangeState}
                      autocomplete="off"
                    />

                    <span className="error_content">
                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group">
                    <label className='form_label'>Postal / Zip Code  </label>
                    <Input
                      className='form_control basic'
                      value={pincode}
                      onBlur={onBlurPincode}
                      onChange={onChangePincode}
                      autocomplete="off"
                    />
                    <span className="error_content">
                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                    <label className='form_label'>Country  *</label>
                    <Select
                      showSearch
                      // open={true}
                      optionFilterProp="label"
                      className={countryIsRequiredError
                        ? "form_select basic error"
                        : "form_select basic"
                      }
                      value={country}
                      onChange={(event) => {
                        setCountryIsRequiredError(false)
                        setCountry(event);
                      }}
                      options={countryOptions}
                    // onSearch={(value) => {
                    //     console.log('search:', value);
                    //   }}
                    />
                    <span className="error_content">
                      {countryIsRequiredError && (
                        <> This field is required</>
                      )}
                    </span>

                  </div>
                </Col>
              </Row>
            </div>
            <h2 className="sub_heading">
              Contact details
            </h2>
            <div className="container_box--form-container">
              <Row gutter={16}>
                <Col span={12}>
                  <div className="form_content_block--group mb_0">
                    <label className='form_label'>Phone Number  *</label>
                    {/* <Space.Compact className='form_compact basic'> */}
                    <div className='input_group'>

                      <ReactSelect
                        value={dialCode}
                        onChange={(event) => {
                          setDialCode(event);
                        }}
                        options={dialCodeOptions}
                        isSearchable={true}
                        // menuIsOpen={true}
                        className="form_select--w-20"
                        classNamePrefix="form_select basic"
                        formatOptionLabel={formatOptionLabel}
                        styles={customStyles}
                        placeholder=""

                      />
                      <Input
                        className={phoneIsRequiredError
                          ? "form_control basic error"
                          : "form_control basic"
                        }
                        value={phone}
                        onBlur={onBlurPhone}
                        onChange={onChangePhone}
                        autocomplete="off"
                      />
                      {/* </Space.Compact> */}
                    </div>
                    <span className="error_content">
                      {phoneIsRequiredError && (
                        <> This field is required</>
                      )}
                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group mb_0">
                    <label className='form_label'>Linkedin URL </label>
                    <Input
                      className={companyLinkedinUrlError
                        ? "form_control basic error"
                        : "form_control basic"
                      }
                      placeholder='https://'
                      value={companyLinkedin}
                      onBlur={onBlurCompanyLinkedin}
                      onChange={onChangeCompanyLinkedin}
                      autocomplete="off"

                    />
                    <span className="error_content">
                      {companyLinkedinUrlError && (
                        <> Invalid LinkedIn Url</>
                      )}
                    </span>

                  </div>
                </Col>
              </Row>
            </div>
            <h2 className="sub_heading">
              Seller details
            </h2>
            <div className="container_box--form-container">
              <Row gutter={16}>
                <Col span={24}>
                  <div className="form_content_block--group">
                    <label className='form_label d_flex'>Seller Type *</label>
                    <Radio.Group onChange={onChangeSellerType} value={sellerType} className="form_radio equal_space">
                      <Radio className='radio_btn' value="Publisher">Publisher</Radio>
                      <Radio className='radio_btn' value="Intermediary">Intermediary</Radio>
                      <Radio className='radio_btn' value="Both">Both</Radio>
                    </Radio.Group>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group mb_0">
                    <label className='form_label'>Seller Name *</label>
                    <Input
                      className={sellerNameIsRequiredError
                        ? "form_control basic error"
                        : "form_control basic"
                      }
                      value={sellerName}
                      onBlur={onBlurSellerName}
                      onChange={onChangeSellerName}
                      autocomplete="off"
                    />
                    <span className="error_content">
                      {sellerNameIsRequiredError && (
                        <> This field is required</>
                      )}
                    </span>


                  </div>
                </Col>
                <Col span={12}>
                  <div className="form_content_block--group mb_0">
                    <label className='form_label'>Seller Domain *</label>
                    <Input
                      className={(sellerDomainIsRequiredError || sellerDomainUrlError)
                        ? "form_control basic error"
                        : "form_control basic"
                      }
                      value={sellerDomain}
                      onBlur={onBlurSellerDomain}
                      onChange={onChangeSellerDomain}
                      autocomplete="off"
                    />
                    <span className="error_content">
                      {sellerDomainIsRequiredError && (
                        <> This field is required</>
                      )}

                      {sellerDomainUrlError && (
                        <> Invalid Domain</>
                      )}
                    </span>


                  </div>
                </Col>
              </Row>
            </div>
            <h2 className="sub_heading">
              GAM Integration
            </h2>
            {/* <Row gutter={16}>

              <Col span={12}>
                <div className="container_box--form-container">

                  <div className="form_content_block--group mb_0 d_flex align_items_center justify_content_between">
                    <label className='form_label form_label_switch'><img src={googleIcon} alt='USP' /> Google Ad Manager 360 (MCM)</label>
                    <Switch checked={isGamChecked} onChange={() => { setIsGamChecked(!isGamChecked) }} />


                  </div>
                </div>
              </Col>
            </Row> */}
            <Row gutter={16} className='mb-5'>
              <Col span={12}>
                <div className="google_ads_design_d2 form_content_block--group">
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center'>
                      <img src={googleIcon} className='img-fluid' alt="" />
                      <label className='form_label'>Google Ad Manager 360 (MCM)</label>
                    </div>
                    <Switch checked={isGamChecked} onChange={() => { setIsGamChecked(!isGamChecked) }}
                    />
                  </div>
                  {isGamChecked &&
                    <div className="form_content_block--group mt_d2_24">
                      <Input className='form_control basic' placeholder="Enter Network ID"
                        value={networkId} onChange={(e) => { setNetworkId(e.target.value) }}
                      />
                    </div>
                  }
                </div>
              </Col>
            </Row>
            <h2 className="sub_heading">
              Media Kit
            </h2>

            <Row gutter={16} className='mb-5'>
              <Col span={24}>
                <div className="form_content_block--group">

                  <label for='file000'
                    className={dragging ? 'ant_upload_drag drag_css_color' : 'ant_upload_drag'}

                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <p className="upload_drag_icon">
                      <img src={uploadIcon} alt='USP' />
                    </p>
                    <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                    <p className="ant_upload_hint">
                      PPT (max. 100 MB)
                    </p>
                  </label>
                  <input className='form_upload d-none' type="file"
                    name="file000"
                    id="file000"
                    accept=".ppt, .pptx"
                    multiple
                    onChange={onChangeMediakit}


                  />

                  {mediakit.map((media, index) => (

                    <div class="ant_upload_list--item">
                      <div class="ant_upload_list--content">
                        <img src={pptIcon} alt="USP" />
                        <div class="ant_upload_list--info">
                          <span class="ant_upload_list--info-name">{media.filename}</span>
                          <span class="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                        </div>
                      </div>
                      <button type="link" class="ant_upload_list--delete"
                        onClick={() => {
                          let tempMediaKit = [...mediakit];
                          tempMediaKit.splice(index, 1);
                          setMediakit(tempMediaKit);
                        }}
                      >
                        <img src={deleteIcon} alt="USP" />
                      </button>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>

            <div className="hr_custom">

            </div>



            {buttonValue ? (
              <button className='btn_primary btn loader'>
                <span>SUBMIT</span>
                <img src={loaderIcon} alt='USP' className='loader_icon' />
              </button>
            ) : (
              <button className='btn_primary btn'
                onClick={handleSubmit}
              >
                <span>submit for Approval</span>
                <img src={loaderIcon} alt='USP' className='loader_icon' />
              </button>
            )}
          </div>


        </div>
      </div>

    )
  }
  else if (step === 2) {
    return (
      <div className="container_box--main">
        <div className="container_box_start">
        </div>

        <div className="container_box_end">
          <div className="container_box_end--width">
            <div className="container_box--intro onb mt_74">
              <h1 className='heading'>Thank you for providing the required information</h1>
              <p className='text'>We'll get back to you within 2-3 business days.</p>
            </div>

            <div className="alert_message--warning">
              <img src={timeIcon} alt='USP' />
              <h2 className='heading'>Profile under review!</h2>
              <p className="text">
                Sit back and Relax your profile is currently under review by our team. We will notify you via email upon successful completion.
              </p>
            </div>
          </div>
        </div>
      </div>

    )
  }
  else {
    return (
      <div
        style={{ width: "100%", height: "100vh" }}
        className="d-flex justify-content-center align-items-center"

      >
        <img
          // src="https://media0.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b952jdpo41hluthq9teb8zgvi4pdqaa1nt4htgdj4ghl&ep=v1_gifs_search&rid=200w.gif&ct=g" 
          src={FullLoader}
          width={50}
          height={50}
          alt="" />
      </div>
    )
  }

};

export default Onboarding;
